import { OnrampApiError } from '../client.js';
export function createWithdrawalClient(transport) {
    function data(result) {
        if (result.data)
            return result.data.data;
        throw new OnrampApiError(result.response.status, result.error?.error.code ?? 'offramp_request_failed', result.error?.requestId);
    }
    return {
        async resumeWithdrawal(id, signal) {
            return data(await transport.GET('/v1/onramp/withdrawals/{id}/checkout', {
                params: { path: { id } },
                ...(signal ? { signal } : {}),
            }));
        },
        async withdrawalContext(currency, surface, signal) {
            return data(await transport.GET('/v1/onramp/withdrawals/context', {
                params: { query: { currency, surface } },
                ...(signal ? { signal } : {}),
            }));
        },
        async quoteWithdrawal(input, signal) {
            return data(await transport.POST('/v1/onramp/withdrawals/quote', {
                body: input,
                ...(signal ? { signal } : {}),
            }));
        },
        async createWithdrawal(input) {
            return data(await transport.POST('/v1/onramp/withdrawals', { body: input }));
        },
        async withdrawal(id, signal) {
            return data(await transport.GET('/v1/onramp/withdrawals/{id}', {
                params: { path: { id } },
                ...(signal ? { signal } : {}),
            }));
        },
        async reserveWithdrawal(id, version, prepare = false) {
            return data(await transport.POST('/v1/onramp/withdrawals/{id}/send', {
                params: { path: { id } },
                body: { version, prepare },
            }));
        },
        async reportWithdrawal(id, signature) {
            return data(await transport.POST('/v1/onramp/withdrawals/{id}/report', {
                params: { path: { id } },
                body: { signature },
            }));
        },
        async cancelWithdrawal(id) {
            return data(await transport.POST('/v1/onramp/withdrawals/{id}/cancel', { params: { path: { id } } }));
        },
    };
}
